module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-e3ea0300.png";